
/**
 * Function used to filter out console warning messages that should not get reported to airbrake
 * Function returns bool value (true if airbrake should notify)
 * @param {*} message , console message to report to airbrake
 */
function notifyAirbrakeWarnings(message) {
  let messageStr = String(message)
  let returnValue = true;
  if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(message)) returnValue = false;
  if (messageStr?.includes('This browser does not support audio output selection.')) returnValue = false;
  if (messageStr?.includes('Unable to set audio output devices. InvalidArgumentError: Devices not found: default')) returnValue = false;
  if (messageStr?.includes('Cannot connect to insights.')) returnValue = false;

  return returnValue;
}

/**
 * Function used to filter out console werror messages that should not get reported to airbrake
 * Function returns bool value (true if airbrake should skip notifying)
 * @param {*} message , console message to report to airbrake
 */
function skipAirbrakeErrors(notice) {
  let returnValue = false;
  const errorTexts = [
    'Could not start video source',
    'Could not start audio source',
    // No leading space: the phrase arrives at the front of the message as often as it arrives behind
    // an element description, and the space stopped it matching the first case at all.
    'Failed to load because no supported source was found',
    'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied',
    'play() request was interrupted',
    'A user gesture is required',
    // Twilio's logger writes [TwilioVoice][<tag>] as its own console argument and the console wrapper
    // forwards only the first one, so a logger line reaches Airbrake as the tag alone. AudioHelper
    // covers device selection and browser capability warnings and never reports a call failure, so
    // its tag is noise. Device, PStream and WSTransport carry the call path, and a bare
    // '[twiliovoice]' prefix here suppressed all three.
    '[TwilioVoice][AudioHelper]',
    // The same device and Insights noise for the paths that deliver a full message, such as
    // window.onerror and unhandled rejections. Named one by one so a gateway, signalling or media
    // error still reaches Airbrake.
    'This browser does not support audio output selection',
    'Unable to set audio output devices',
    'Cannot connect to insights',
    'Unable to post metrics to Insights',
    'event to Insights. Received error',
    // What the bare 'getUserMedia' entry was reaching for. A real microphone failure now reports;
    // the noisy hardware and permission cases are already named above.
    'Calling getUserMedia after device change',
    'Unable to updateAvailableDevices after gUM call',
  ]
  if (notice == 'Error') returnValue = true;
  if (notice == 'PostHog.js') returnValue = true;
  // The list holds fragments to look for inside the reported message, so the message is what has to
  // do the containing. Reversed, the comparison was always false and filtered nothing.
  if (notice.errors?.some(err => errorTexts.some(msg => err.message?.toLowerCase()?.includes(msg.toLowerCase())))) returnValue = true;

  return returnValue;
}

export {
  notifyAirbrakeWarnings,
  skipAirbrakeErrors,
}
